// DISCIPLAY — Product SVG placeholders
// Port of ProductSVGs.jsx — exports renderProductSvg(productId, hovered) returning an HTMLElement.
// Used by product-card.liquid when no product image is uploaded (dev fallback).
// In production, real product images from Shopify Admin take precedence.

(function () {
  'use strict';
  const PALETTE = { stroke: '#FF0033', muted: '#2a2a2a', dim: '#1a1a1a' };

  // Minimal placeholder. The full set of 8 designs lives in the React source
  // (ui_kits/website/ProductSVGs.jsx) — re-port phase by phase as PDP launches.
  function renderProductSvg(id, hovered) {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 240 240');
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', '100%');
    svg.style.background = '#0a0a0a';

    const g = document.createElementNS(ns, 'g');
    g.setAttribute('stroke', PALETTE.stroke);
    g.setAttribute('stroke-width', '1.4');
    g.setAttribute('fill', 'none');

    [60, 80, 100].forEach((r) => {
      const c = document.createElementNS(ns, 'circle');
      c.setAttribute('cx', '120'); c.setAttribute('cy', '120'); c.setAttribute('r', r);
      c.setAttribute('opacity', String(0.6 - r * 0.004));
      g.appendChild(c);
    });

    const t = document.createElementNS(ns, 'text');
    t.setAttribute('x', '120'); t.setAttribute('y', '128');
    t.setAttribute('text-anchor', 'middle');
    t.setAttribute('fill', '#1c1c1c');
    t.setAttribute('font-size', '10');
    t.setAttribute('font-family', 'Montserrat');
    t.setAttribute('letter-spacing', '4');
    t.textContent = 'PRODUCT';
    g.appendChild(t);

    svg.appendChild(g);
    return svg;
  }

  // Auto-hydrate: any element with [data-product-svg="<id>"] gets an SVG inside on load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-svg]').forEach((el) => {
      const id = el.getAttribute('data-product-svg');
      el.appendChild(renderProductSvg(id, false));
    });
  });

  window.DISCIPLAY = window.DISCIPLAY || {};
  window.DISCIPLAY.renderProductSvg = renderProductSvg;
})();
